import { InteractionStatus, IPublicClientApplication } from '@azure/msal-browser';
import { removeTokensFromLocalStorage } from '../libs/auth';

export async function handleLogout(
  instance: IPublicClientApplication,
  isAuthenticated: boolean,
  inProgress: InteractionStatus,
  sessionExpired = false
) {
  if (isAuthenticated && inProgress === InteractionStatus.None) {
    try {
      const accounts = instance.getAllAccounts();
      if (accounts.length === 0) {
        console.warn('No accounts found.');
        return;
      }

      const postLogoutRedirectUri = sessionExpired
        ? `${process.env.REACT_APP_MSAL_REDIRECT_URI}?sessionExpired=true`
        : process.env.REACT_APP_MSAL_REDIRECT_URI;

      const logoutRequest = {
        account: accounts[0],
        logoutHint: accounts[0].username,
        postLogoutRedirectUri
      };

      removeTokensFromLocalStorage();
      await instance.logoutRedirect(logoutRequest);
    } catch (err) {
      console.error('Logout error:', err);
    }
  } else {
    console.log('User is not authenticated or logout is in progress.');
  }
}
